/**
 * Logo TUOTAX — Torii-inspired
 * Concept: le due T come colonne di un torii, unite da una trave orizzontale continua
 * (kasagi). La trave in sfumatura terracotta caldo → chiaro suggerisce le due T
 * mantenendo l'impressione di un tutt'uno.
 */

export function LogoIcon({ size = 36, className = "" }) {
  return (
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="TUOTAX"
    >
      <defs>
        <linearGradient id="tuotax-beam" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0" stopColor="hsl(14 69% 58%)" />
          <stop offset="1" stopColor="hsl(20 70% 72%)" />
        </linearGradient>
      </defs>
      {/* Sfondo verde bosco */}
      <rect width="48" height="48" rx="12" fill="hsl(155 27% 25%)" />
      {/* Trave superiore continua (kasagi torii) — sfumatura T1 → T2 */}
      <rect x="5" y="11" width="38" height="5" rx="2" fill="url(#tuotax-beam)" />
      {/* Gamba T sinistra (terracotta caldo) */}
      <rect x="14" y="16" width="4" height="21" rx="1.5" fill="hsl(14 69% 58%)" />
      {/* Gamba T destra (terracotta chiaro) */}
      <rect x="30" y="16" width="4" height="21" rx="1.5" fill="hsl(20 70% 72%)" />
    </svg>
  );
}

export function LogoWordmark({ className = "" }) {
  return (
    <span className={`font-heading font-bold tracking-tight inline-flex items-baseline ${className}`}>
      <span style={{ color: "hsl(14 69% 58%)" }}>T</span>
      <span>UO</span>
      <span style={{ color: "hsl(20 70% 72%)" }}>T</span>
      <span>AX</span>
    </span>
  );
}

export default function Logo({ iconSize = 36, showText = true, textClassName = "text-xl", tagline }) {
  return (
    <div className="inline-flex items-center gap-2.5">
      <LogoIcon size={iconSize} />
      {showText && (
        <div className="flex flex-col leading-none">
          <LogoWordmark className={textClassName} />
          {tagline && <span className="text-[10px] text-muted-foreground mt-1">{tagline}</span>}
        </div>
      )}
    </div>
  );
}
